module.exports = __webpack_public_path__ + "img/xlstemplate.135ac130.png";